<template>
  <ams-select-table
    :heading="select_table_heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :filtering="filtering"
    :describe_belongs_to="describe_belongs_to"
    :pre_selected_items="pre_selection"
    :select_mode="mode_selection"
    @selectedRows="selectRows"
  />
</template>

<script>
import AmsSelectTable from './AmsSelectTable.vue'

export default {
  components: {
    AmsSelectTable
  },
  props: {
    pre_selection: {
      Type: Array
    },
    select_table_heading: {
      Type: String
    },
    filtering: {
      Type: Object
    }
  },
  data() {
    return {
      mode_selection: 'single',
      ams_type: 'product-listings',
      ams_api_path: 'api/admin/v1',
      ams_fields: [
       { 
          key: 'attributes.edition',
          label: 'Edition',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc' 
        },
        {
          key: 'attributes.price-cents',
          label: 'Price',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc'
        },
       { 
          key: 'attributes.description',
          label: 'Description',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'brands',
          description_attr: 'name',
          append: ': '
        },
        {
          prepend: '',
          type: 'product-models',
          description_attr: 'name',
          append: ''
        }
      ]
    }
  },
  methods: {
    selectRows(items) {
      this.$emit('selectedItems', items)
    }
  }
}
</script>